/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import i18next from 'i18next';

import {
  getCustomerIssuedCoupons,
  getIsDefaultCustomer,
  getSelectedCustomer,
  getAddressTypes as getAddressTypesSelector,
  getSelectedCustomerID,
  getSelectedCustomerAddresses,
} from 'reducers/customerSearch';
import { getSelectedPos } from 'reducers/PointsOfSale';
import { applyCoupons, calculate } from 'actions/ShoppingCart';
import { addTooltip, resetTooltips } from 'actions/UI';
import * as campaignsApi from 'services/ErplyAPI/campaigns';
import * as api from 'services/ErplyAPI/customers';
import * as customerActionsTypes from 'constants/customerSearch';
import { ErplyAttributes, hasBirthday } from 'utils';
import { addError } from 'actions/Error';
import { getCurrentPosLanguage, getSetting } from 'reducers/configs/settings';
import { openModalPage } from 'actions/modalPage';
import { modalPages as mp } from 'constants/modalPage';
import { createConfirmation } from 'actions/Confirmation';
import { getIsAReturn } from 'reducers/sales';
import { getPluginLifecycleHook } from 'reducers/Plugins';
import { getAllAppliedCoupons } from 'reducers/ShoppingCart';

import { withProgressAlert } from './actionUtils';

export const deselectCustomer = () => ({
  type: customerActionsTypes.RESET_CUSTOMER,
});

export const getDefaultCustomer = () => async (dispatch, getState) => {
  dispatch({ type: customerActionsTypes.GET_DEFAULT_CUSTOMER.START });
  try {
    const { pointOfSaleID } = getSelectedPos(getState());
    const [data] = await api.getDefaultCustomer({ pointOfSaleID });
    if (data && data.id) {
      const result = await api.getCustomers({
        customerID: data.id,
        getAddresses: 1,
        getBalanceInfo: 1,
        getBalanceWithoutPrepayments: 1,
      });
      const [customer] = result;
      dispatch({
        type: customerActionsTypes.GET_DEFAULT_CUSTOMER.SUCCESS,
        data: customer,
      });
    } else {
      dispatch(addError('No default customer configured'));
      dispatch({
        type: customerActionsTypes.GET_DEFAULT_CUSTOMER.SUCCESS,
        data: {},
      });
    }
  } catch (err) {
    console.error('Unable to load default customer', err);
    dispatch({
      type: customerActionsTypes.GET_DEFAULT_CUSTOMER.ERROR,
      data: err,
    });
  }
};
export const getOneCustomer = (customerID, searchCode = '') => async () => {
  if (!customerID && searchCode.length === 0)
    throw new Error('Customer ID or searchCode is missing');

  const [data] = await api.getCustomers({
    customerID,
    getAddresses: 1,
    getBalanceInfo: 1,
    getBalanceWithoutPrepayments: 1,
    searchCode,
  });
  api.logProcessingOfCustomerData(`${customerID}`);
  const [{ points }] = await api.getCustomerRewardPoints(data.customerID);
  return { customer: data, points };
};
export const selectOneCustomer = props => async (dispatch, getState) => {
  const { customerID, searchCode = '' } = props;
  dispatch({ type: customerActionsTypes.SET_ONE_CUSTOMER });
  const { before, on, after } = getPluginLifecycleHook('onSelectOneCustomer')(
    getState(),
  );
  try {
    await dispatch(before(props));
    const { customer, points } = await dispatch(
      getOneCustomer(customerID, searchCode),
    );

    const allowInvoicesForContactPersons = getSetting(
      'allowCreateInvForContactPerson',
    )(getState());
    if (!!customer.companyID && !allowInvoicesForContactPersons) {
      dispatch(
        addError(
          i18next.t('alerts:customers.invoicesForContactPersonNotAllowed'),
        ),
      );
      return;
    }

    const payload = await dispatch(
      on(props, { ...customer, rewardPoints: points }),
    );
    dispatch({
      type: customerActionsTypes.SET_ONE_CUSTOMER_SUCCESS,
      data: payload,
    });
    await dispatch(after(props, payload));
  } catch (e) {
    console.error('Unable to select customer', props, e);
    dispatch({ type: customerActionsTypes.SET_ONE_CUSTOMER_ERROR, data: e });
  }
};

export const getCustomerStoreCredit = customerID => async dispatch => {
  dispatch({
    type: customerActionsTypes.GET_CUSTOMER_STORE_CREDIT,
    payload: {},
  });
  try {
    const [{ availableCredit }] = await api.getCustomers({
      customerID,
      getBalanceInfo: 1,
    });
    dispatch({
      type: customerActionsTypes.GET_CUSTOMER_STORE_CREDIT_SUCCESS,
      payload: availableCredit,
    });
  } catch (e) {
    console.error('Unable to load store credit for customer', customerID, e);
    dispatch({
      type: customerActionsTypes.GET_CUSTOMER_STORE_CREDIT_SUCCESS,
      payload: 0,
    });
  }
};

export const getCustomerRewardPoints = customerID => async dispatch => {
  dispatch({ type: customerActionsTypes.GET_CUSTOMER_REWARD_POINTS });
  try {
    const [{ points }] = await api.getCustomerRewardPoints(customerID);
    dispatch({
      type: customerActionsTypes.GET_CUSTOMER_REWARD_POINTS_SUCCESS,
      data: points,
    });
  } catch (error) {
    console.error(
      'Unable to load reward points for customer',
      customerID,
      error,
    );
    dispatch({
      type: customerActionsTypes.GET_CUSTOMER_REWARD_POINTS_ERROR,
      error,
    });
  }
};

export const setCustomerIssuedCoupons = ({ customerID }) => async (
  dispatch,
  getState,
) => {
  dispatch({ type: customerActionsTypes.SET_CUSTOMER_ISSUED_COUPONS.START });
  try {
    const issuedCoupons = getIsDefaultCustomer(getState())
      ? []
      : await campaignsApi.getIssuedCoupons({
          issuedCustomerID: customerID,
          recordsOnPage: 100,
          status: 'ACTIVE',
        });
    dispatch({
      type: customerActionsTypes.SET_CUSTOMER_ISSUED_COUPONS.SUCCESS,
      data: issuedCoupons,
    });
  } catch (error) {
    console.error(
      'Unable to load issued coupons for customer',
      customerID,
      error,
    );
    dispatch({
      type: customerActionsTypes.SET_CUSTOMER_ISSUED_COUPONS.ERROR,
      error,
    });
  }
};

// set customer
export const setCustomer = ({
  data,
  firstName = '',
  lastName = '',
  recalculateShoppingCart = true,
  displayCouponsInfo = false,
  fetchRewardPoints = true,
  companyName = '',
}) => async (dispatch, getState) => {
  const { before, on, after } = getPluginLifecycleHook('onSetCustomer')(
    getState(),
  );
  dispatch({ type: customerActionsTypes.SET_CUSTOMER });
  try {
    await dispatch(
      before({
        data,
        firstName,
        lastName,
        recalculateShoppingCart,
        displayCouponsInfo,
        fetchRewardPoints,
        companyName,
      }),
    );
    const customerID = typeof data === 'object' ? data.customerID : data;
    let isOffline = false;
    const payload = await (typeof data === 'object'
      ? Promise.resolve(data)
      : api
          .getCustomers({
            customerID,
            getAddresses: 1,
            getBalanceInfo: 1,
            getBalanceWithoutPrepayments: 1,
          })
          .then(a => {
            return a[0];
          })
    ).catch(async err => {
      // prettier-ignore
      console.warn('Unable to load customer', customerID, ', assuming connecing issue', err);
      isOffline = true;
    });
    if (isOffline) throw new Error('Action cancelled');
    if (!customerID) {
      dispatch(addError('Can not set customer without `customerID`'));
      throw new Error('Action cancelled');
    }
    const allowInvoicesForContactPersons = getSetting(
      'allowCreateInvForContactPerson',
    )(getState());
    if (!!payload.companyID && !allowInvoicesForContactPersons) {
      dispatch(
        addError(
          i18next.t('alerts:customers.invoicesForContactPersonNotAllowed'),
        ),
      );
      throw new Error('Action cancelled');
    }

    const previousCustomerID = getSelectedCustomerID(getState());
    const previousAppliedCoupons = getAllAppliedCoupons(getState());

    const customerData = await dispatch(
      on(
        {
          data,
          firstName,
          lastName,
          recalculateShoppingCart,
          displayCouponsInfo,
          fetchRewardPoints,
        },
        payload,
      ),
    );
    // Initial set without rewardPoints
    await dispatch({
      type: customerActionsTypes.SET_CUSTOMER_SUCCESS,
      data: { rewardPoints: 0, availableCredit: 0, ...customerData },
    });
    // Fetch rewardPoints and storeCredit following in parallel
    if (fetchRewardPoints) dispatch(getCustomerRewardPoints(customerID));
    // Display tooltip in case a customer has active coupons
    await dispatch(setCustomerIssuedCoupons({ customerID }));

    if (recalculateShoppingCart) await dispatch(calculate());

    const customerIssuedCoupons = getCustomerIssuedCoupons(getState());
    const isAReturn = getIsAReturn(getState());
    const showNotesPopup = getSetting('touchpos_display_notes_popup')(
      getState(),
    );
    const message = i18next.t('alerts:customerNotes.message', {
      note: customerData.notes,
    });
    if (customerData?.notes?.trim() && showNotesPopup) {
      dispatch(
        createConfirmation(
          () => {
            /* do nothing */
          },
          null,
          {
            title: i18next.t('alerts:customerNotes.title'),
            body: message,
          },
        ),
      );
    }

    if (displayCouponsInfo) {
      const totalCoupons = customerIssuedCoupons.length;
      if (totalCoupons && !isAReturn) {
        const displayLimit = 6;
        const coupons = customerIssuedCoupons
          .map(coupon => coupon.uniqueIdentifier)
          .slice(0, displayLimit)
          .join(',\n');
        const content = (
          <p style={{ margin: 0 }}>
            {i18next.t('alerts:customerTooltips.activeCoupons', {
              context: totalCoupons < displayLimit ? 'few' : 'many',
              coupons,
              extra: Math.max(0, totalCoupons - displayLimit),
            })}
          </p>
        );

        if (getSetting('touchpos_disable_unused_coupons_popup')(getState())) {
          dispatch(addTooltip({ content }));
        } else {
          new Promise((res, rej) =>
            dispatch(
              createConfirmation(res, rej, {
                title: 'Confirmation',
                body: i18next.t(
                  'alerts:customerTooltips.unusedCoupons',
                  customerData,
                ),
              }),
            ),
          ).then(() =>
            dispatch(
              openModalPage({
                component: mp.saleCoupons,
                props: { apply: customerIssuedCoupons },
              }),
            ),
          );
        }
      } else if (
        customerData.customerType === 'PERSON' &&
        hasBirthday(customerData.birthday)
      ) {
        const content = (
          <p style={{ margin: 0 }}>
            {i18next.t('alerts:customerTooltips.birthday')}
          </p>
        );
        dispatch(addTooltip({ content }));
      } else {
        dispatch(resetTooltips());
      }
    } else if (previousCustomerID === customerID) {
      const couponsToApply = previousAppliedCoupons.filter(
        coupon => coupon.issuedCustomerID === customerID,
      );
      if (couponsToApply.length) dispatch(applyCoupons(couponsToApply));
    }

    // PLUGIN - after action hook
    dispatch(
      after(
        {
          data,
          firstName,
          lastName,
          recalculateShoppingCart,
          displayCouponsInfo,
          fetchRewardPoints,
        },
        customerData,
      ),
    );
  } catch (err) {
    console.error('Unable to set customer', err);
    dispatch({
      type: customerActionsTypes.SET_CUSTOMER_ERROR,
      data: err,
    });
  }
};

export const getCustomerGroups = () => async dispatch => {
  dispatch({ type: customerActionsTypes.GET_CUSTOMER_GROUPS });
  try {
    const data = await api.getCustomerGroups();
    dispatch({ type: customerActionsTypes.GET_CUSTOMER_GROUPS_SUCCESS, data });
    return data;
  } catch (err) {
    console.error('Unable to load customer groups', err);
    dispatch({
      type: customerActionsTypes.GET_CUSTOMER_GROUPS_ERROR,
      data: err,
    });
    return [];
  }
};

export const fetchAddressTypes = () => async (dispatch, getState) => {
  dispatch({ type: customerActionsTypes.GET_ADDRESS_TYPES_START });
  try {
    const lang = getCurrentPosLanguage(getState());
    const data = await api.getAddressTypes({ lang });
    dispatch({ type: customerActionsTypes.GET_ADDRESS_TYPES_SUCCESS, data });
  } catch (err) {
    console.error('Unable to load address types', err);
    dispatch({
      type: customerActionsTypes.GET_ADDRESS_TYPES_ERROR,
      data: err,
    });
  }
};

export const fetchPersonTitles = () => async (dispatch, getState) => {
  dispatch({ type: customerActionsTypes.GET_PERSON_TITLES_START });
  try {
    const lang = getCurrentPosLanguage(getState());
    const data = await api.getPersonTitles({ lang });
    dispatch({ type: customerActionsTypes.GET_PERSON_TITLES_SUCCESS, data });
  } catch (err) {
    console.error('Unable to load person titles (for customers)', err);
    dispatch({
      type: customerActionsTypes.GET_PERSON_TITLES_ERROR,
      data: err,
    });
  }
};

export const fetchJobTitles = () => async (dispatch, getState) => {
  dispatch({ type: customerActionsTypes.GET_JOB_TITLES_START });
  try {
    const lang = getCurrentPosLanguage(getState());
    const data = await api.getJobTitles({ lang });
    dispatch({ type: customerActionsTypes.GET_JOB_TITLES_SUCCESS, data });
  } catch (err) {
    console.error('Unable to load job titles (for employees)', err);
    dispatch({
      type: customerActionsTypes.GET_JOB_TITLES_ERROR,
      data: err,
    });
  }
};

export const createCustomer = props => async dispatch => {
  dispatch({ type: customerActionsTypes.SAVE_CUSTOMER });
  try {
    const response = await api.saveCustomer(props);
    dispatch({ type: customerActionsTypes.SAVE_CUSTOMER_SUCCESS });
    return response;
  } catch (err) {
    dispatch({ type: customerActionsTypes.SAVE_CUSTOMER_ERROR, data: err });
    throw err;
  }
};

export const saveAddress = address => async dispatch => {
  dispatch({ type: customerActionsTypes.SAVE_ADDRESS });
  try {
    await api.saveAddress(address);
    dispatch({ type: customerActionsTypes.SAVE_ADDRESS_SUCCESS });
  } catch (err) {
    dispatch({ type: customerActionsTypes.SAVE_ADDRESS_SUCCESS, data: err });
    throw new Error('Unable to save address', { cause: err });
  }
};

export const deleteAddress = addressID => async dispatch => {
  dispatch({ type: customerActionsTypes.DELETE_ADDRESS });
  try {
    await api.deleteAddress({ addressID });
    dispatch({
      type: customerActionsTypes.DELETE_ADDRESS_SUCCESS,
      data: addressID,
    });
  } catch (err) {
    dispatch({ type: customerActionsTypes.DELETE_ADDRESS_ERROR, data: err });
    throw new Error('Unable to delete address', { cause: err });
  }
};

export const updateAddresses = (saveAddresses, deleteAddresses) => async (
  dispatch,
  getState,
) => {
  try {
    await Promise.all([
      ...saveAddresses.map(address => dispatch(saveAddress(address))),
      ...deleteAddresses.map(address =>
        dispatch(deleteAddress(address.addressID)),
      ),
    ]);
  } catch (err) {
    console.error('Error while bulk editing multiple addresses', err);
    dispatch(addError(i18next.t('alerts:errors.failedBulkAddressUpdate')));
  }
  const { customerID } = getSelectedCustomer(getState());
  await dispatch(selectOneCustomer({ customerID }));
  await dispatch(setCustomer({ data: getSelectedCustomer(getState()) }));
  return getSelectedCustomerAddresses(getState()) ?? [];
};

const saveCustomerBase = (props, callback) => async (dispatch, getState) => {
  const state = getState();
  const { before, on, after } = getPluginLifecycleHook('onSaveCustomer')(state);

  try {
    dispatch(before(props));

    /* companyTypeID is present to avoid duplicates when editing existing
      customers (companies) with an already specified companyType
    */
    const {
      // newAddress,
      addressTypeID,
      companyTypeID,
      addresses,
      attributes,
      ...rest
    } = props;

    const abort = Symbol('abort');
    const data = await dispatch(
      on(props, { params: rest, attributes, addresses }),
    ).catch(() => abort);
    if (data === abort) return;

    const response = await dispatch(
      createCustomer({
        ...data.params,
        ...new ErplyAttributes(data.attributes).asFlatArray,
      }),
    );

    const { customerID } = response[0];

    if (data.addresses?.[0]) {
      const [{ id: defaultAddressType }] = getAddressTypesSelector(getState());
      await dispatch(
        saveAddress({
          ...addresses[0],
          ownerID: customerID,
          typeID: (addresses[0].typeID ?? addressTypeID) || defaultAddressType,
        }),
      );
    }
    await dispatch(after(props, customerID));
    await dispatch(selectOneCustomer({ customerID }));
    await dispatch(setCustomer({ data: getSelectedCustomer(getState()) }));
    if (callback) callback();
  } catch (err) {
    dispatch(addError(err.message));
    console.error('Error while saving customer', err);
  }
};

export const saveCustomer = withProgressAlert('alerts:createCustomer.saving')(
  saveCustomerBase,
);
